<div *ngIf="medicalOffice.name" [className]="medicalOfficeNameIsLarge ? 'body-1' : 'body-4'">
  {{ medicalOffice.name }}
</div>
<div *ngIf="medicalOffice.office" class="body-4">
  {{ medicalOffice.office }}
</div>
<div class="body-4">{{ getLocation() }}</div>
